export const asosGlobalNamespace = "asos";
export const siteChromeGlobalNamespace = "siteChrome";
export const sdkGlobalNamespace = "sdk";
export const customerGlobalNamespace = "customer";
export const savedItemsSdkGlobalNamespace = "savedItemsSdk";
export const manifestWindowKey = "_versionManifest";
export const featureManifestWindowKey = "featureManifest";
export const siteChromeInitialStore = "_initialStore";
export const siteChromeTokenValues = "_tokenValues";
export const RECENT_SEARCHES_KEY = "_asosRecentSearches";
export const siteChromeClientConfig = "_config";
export const clientEnvPrefix = "CLIENT_";
export const siteChromeTokenValuePlatform = "platform";
export const siteChromeTokenValueGender = "gender";

export const APP_ROUTES = {
  BAG_LINK: "bag",
  MY_ACCOUNT_SIGNUP_LINK: "register",
  SAVED_ITEMS_LINK: "saved-lists/"
};
